import { gql } from '__generated__';

export default gql(`
  mutation RemoveTeamMember($id: ID!) {
    removeTeamMember(id: $id) {
      id
    }
  }
`);
